import { render } from "./study_plan_component.vue?vue&type=template&id=774380e9"
import script from "./study_plan_component.vue?vue&type=script&lang=js"
export * from "./study_plan_component.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__